export const CUSTOM_TEXT_FIELD_ID = 'custom-text-field-container';
